import React, { ChangeEvent, createRef, RefObject } from 'react'
import './file-input.sass'


class FileInput extends React.Component<{
	onChange?: (f: File) => void
	accept: string,
	btnText:string,
	iconClassName:string
	buttonClassName?:string,
	txtButton?:string,
	heigth?:number,
}, {accept:string}> {

	fileInput: RefObject<HTMLInputElement>

	constructor(props: any) {
		super(props)

		this.fileInput = createRef()

		this.changeHandler = this.changeHandler.bind(this)
		this.redirectToInput = this.redirectToInput.bind(this)
	}

	changeHandler(e: ChangeEvent<HTMLInputElement>) {
		const inputFileElem = e.target

		// send selected file to it
		if (this.props.onChange && inputFileElem.files?.length) {
			const file = inputFileElem.files[0]
			this.props.onChange(file)
		}
	}

	redirectToInput() {
		this.fileInput.current?.click()
	}

	render() { 
		return (
			<div className="form-group file-input-wrapper" style={{height:this.props.heigth}}>
				<input type="file" accept={this.props.accept} ref={this.fileInput} className="d-none"
					onChange={this.changeHandler} />

				<button title={this.props.btnText}
					className={`btn ${this.props.buttonClassName}`} 
					onClick={e => this.redirectToInput()}>
					{this.props.txtButton?this.props.txtButton:<span className={this.props.iconClassName}> </span>}
				</button>
				{/* <div className="badge text-body"><span> {this.props.btnText} </span></div> */}
			</div>
		)
	}
}

export default FileInput